import {
    DESKTOP_DEVICE_OS_OPTIONS,
    INAPP_DEVICES_OS_OPTIONS,
} from 'forms/ad-form/services/default-values';

export const payload_formData = {
    // --- Basics ---//
    is_default_preset: false,

    // --- Name ---//
    ad_preset_name: '',
    // --- Budget & Optimizations ---//
    max_cpm_rate_local: 0,

    // --- Geo ---//

    geotargets: [],
    geoboxes: [],

    target_genders: [],
    target_age_groups: [],
    // Cross-platform ad-new defaults (INAPP + DESKTOP), not static ad-form payload_formData
    target_device_os: [
        ...INAPP_DEVICES_OS_OPTIONS.map(os => os.value),
        ...DESKTOP_DEVICE_OS_OPTIONS.map(os => os.value),
    ],
    target_carriers: [],
    carriers_exclude: [],
    target_device_language: [],
    target_device_language_exclude: [],

    // --- Inventory ---//
    target_dooh_publishers: [],
    target_dooh_publishers_exclude: [],

    // Checklist tree lives in getDefaults() (AdPresetPropertyDisplayNames) — do not ship a divergent copy here.
};
